import { Injectable } from '@angular/core';
import { Helper } from 'src/app/shared/helper';
import { ApiService } from 'src/app/data/services/api.service';
import { apiColletions } from 'src/app/core/constant/api-collection';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AdminSettingsService {

    private _settingsUpdate = new BehaviorSubject<any>(null);
    _settingsObservable = this._settingsUpdate.asObservable();
    private _eTemalateUpdate = new BehaviorSubject<any>(null);
    _eTamplateObservable = this._eTemalateUpdate.asObservable();
    private _smsTemalateUpdate = new BehaviorSubject<any>(null);
    _smsTamplateObservable = this._smsTemalateUpdate.asObservable();

    constructor(private _api: ApiService, public _helper: Helper) { }

    getAdminDetails(parameters: any={ useLocalizedFields: true}): Observable<boolean> {        
        return new Observable<boolean>((observer) => {
            this._api.get({ url: apiColletions.getAdminSettings, parameters }).subscribe({
                next: (response: any) => {                    
                    if (response.data) {
                        this._helper.adminSettings = response.data.data[0];
                        observer.next(response.data.data);
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }
    
    sendMessage(parameters: any): Observable<boolean> {
        return new Observable<any>((observer) => {
            this._api.post({ url: apiColletions.sendMessage, parameters }).subscribe({
                next: (response) => {
                    if (response.data) {
                        observer.next({ data: response.data});
                        observer.complete();
                    } else {
                        observer.next(false);
                        observer.complete();
                    }
                },
                error: () => {
                    observer.next(false);
                    observer.complete();
                }
            });
        });
    }
}
